import { SET_DEALERS_FILTERS } from '../actions/filters';

const initialState = {
    searchText: '',
    company: {},
    status: {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_DEALERS_FILTERS: {
            return {
                ...state,
                searchText: action.payload.searchText,
                company: action.payload.company,
                status: action.payload.status
            };
        }

        default:
            return state;
    }
};
